<!-- {{gVenituriOperationale}}
    <google-chart
    type="Line"
    [data]="gVenituriOperationale"
    [columnNames]="['Venituri operationale','Evolutie']"
    [options]="optionsChart"
    [width]="800"
    [height]="600"
    *ngIf="!loadingSlides"
>
</google-chart> -->

<div class="btn-row-2" style="margin-left: auto; margin-right: auto; width: 324px; margin-top: 2rem; margin-bottom: 2rem;">
  <button class="evolution-button" (click)="goToCompare()">
    Tabele Comparații
    <span class="button-custom-icon">
      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF"><path d="M120-120v-720h720v720H120Zm60-500h600v-160H180v160Zm220 220h160v-160H400v160Zm0 220h160v-160H400v160ZM180-400h160v-160H180v160Zm440 0h160v-160H620v160ZM180-180h160v-160H180v160Zm440 0h160v-160H620v160Z"/></svg>
    </span>
  </button>
</div>

<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
  <div nz-col class="gutter-row" [nzSpan]="1"></div>
  <div nz-col class="gutter-row" [nzSpan]="22">
    <h2 style="text-align: center">Grafice de Performanta a Perioadei</h2>
    <!-- <div class="inner-box">
      <h4 style="text-align: center">
        <span *ngFor="let d of charts['c3']['ch1']['title'] | keyvalue : originalOrder">{{ d.value }}</span>
      </h4>
      <google-chart type="ColumnChart" [data]="charts['c3']['ch1']['data']" [columnNames]="charts['c3']['ch1']['columnNames']" [options]="optionsChart" style="width: 95%; height: 300px; margin-left: auto; margin-right: auto"></google-chart>
    </div> -->

    <div class="inner-box">
      <h4 style="text-align: center">
        <span *ngFor="let d of charts['c3']['ch2']['title'] | keyvalue : originalOrder">{{ d.value }}</span>
      </h4>

      <google-chart type="ColumnChart" [data]="charts['c3']['ch2']['data']" [columnNames]="charts['c3']['ch2']['columnNames']" [options]="optionsChart" style="width: 95%; height: 300px; margin-left: auto; margin-right: auto"></google-chart>
    </div>

    <h2 style="text-align: center">Grafice de Evolutie Performanta (venituri, Cheltuieli, EBITDA, Profit Net)</h2>
    <div class="inner-box" *ngFor="let c of charts['c1'] | keyvalue : originalOrder">
      <h4 style="text-align: center">{{ c.key }}</h4>
      <google-chart type="LineChart" [data]="c.value" [columnNames]="[c.key, 'Evolutie', { type: 'number', role: 'annotation' }]" [options]="optionsChart" style="width: 95%; height: 300px; margin-left: auto; margin-right: auto"></google-chart>
    </div>

    <h2 style="text-align: center">Grafice de Evolutie Patrimoniu & Surse de Finantare</h2>
    <div class="inner-box" *ngFor="let c of charts['c2'] | keyvalue : originalOrder">
      <h4 style="text-align: center">{{ c.key }}</h4>

      <google-chart type="LineChart" [data]="c.value" [columnNames]="[c.key, 'Evolutie', { type: 'number', role: 'annotation' }]" [options]="optionsChart" style="width: 95%; height: 300px; margin-left: auto; margin-right: auto"></google-chart>
    </div>
  </div>
  <!-- <div *ngFor="let c of charts['c1'] | keyvalue">
  {{ c.key }}
  <google-chart
    type="Line"
    [data]="c.value"
    [columnNames]="[c.key, 'Evolutie']"
    [options]="optionsChart"
    [width]="800"
    [height]="600"
  >
  </google-chart>
</div> -->
</div>
